import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetSupplierPickerResponse } from '@/api/handlers/resources/suppliers/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { SupplierQueryKeys } from './supplierQueryKeys';

/**
 * Reads `GET /suppliers/picker` (BOS-83) — the full, unpaginated supplier list
 * for form dropdowns and import name-matching. Unlike `/details` this never
 * truncates, so any UI that needs *all* suppliers should use this.
 */
export const useSupplierPickerQuery = (enabled = true) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetSupplierPickerResponse>>({
        queryKey: SupplierQueryKeys.picker(),
        queryFn: () => apiClient.suppliers.getSupplierPicker(),
        enabled,
        staleTime: 60_000,
    });
};
